// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingDots--loader--3AzRT","bouncedelay":"LoadingDots--bouncedelay--_IZG7","dark":"LoadingDots--dark--3Aq-s","light":"LoadingDots--light--2DPOE"};